const FieldTypes = {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  ACCOUNT_NUMBER: 'account_number',
  SIGNATURE: 'signature',
  DATE: 'date',
  PHONE: 'phone',
};
const fieldIconTypes = (fieldType) => {
  switch (fieldType) {
    case FieldTypes.TEXT:
      return { type: FieldTypes.TEXT, icon: ['far', 'text-size'] };
    case FieldTypes.CHECKBOX:
      return { type: FieldTypes.CHECKBOX, icon: ['fas', 'square-check'] };
    case FieldTypes.SIGNATURE:
      return { type: FieldTypes.SIGNATURE, icon: ['fas', 'signature'] };
    case FieldTypes.ACCOUNT_NUMBER:
      return { type: FieldTypes.ACCOUNT_NUMBER, icon: ['fas', 'hashtag'] };
    case FieldTypes.DATE:
      return { type: FieldTypes.DATE, icon: ['fas', 'calendar'] };
    case FieldTypes.PHONE:
      return { type: FieldTypes.PHONE, icon: ['fas', 'phone'] };
    default:
      return { type: FieldTypes.TEXT, icon: ['far', 'text-size'] };
  }
};

export { FieldTypes, fieldIconTypes };
